import React from 'react';
import PropTypes from 'prop-types';
import {Button, Modal} from "react-bootstrap";
import {I18nUtils} from "../../../i18n/I18nUtils";

const TEXTS = {
    title: I18nUtils.tr('TR_ASIGNAR_EMPRESA_COMO_SUBCONTRATA'),
    body1: I18nUtils.tr('TR_LA_EMPRESA_QUE_INTENTA_ANADIR_YA_EXISTE'),
    body2: I18nUtils.tr('TR_DESEA_ASIGNAR_ESTA_EMPRESA_COMO_SUBCONTRATA'),
    buttonLabelCancel: I18nUtils.tr('TR_CANCELAR'),
    buttonLabelAccept: I18nUtils.tr('TR_ACEPTAR'),
};

export default class OutsourceAssignmentConfirmModal extends React.Component {

    render() {
        const {
            show,
            onHide,
            onAccept,
        } = this.props;

        return (
            <Modal
                show={show}
                aria-labelledby="contained-modal-title-sm"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-sm">
                        {TEXTS.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <h4>{TEXTS.body1}</h4>
                    <p><small>{TEXTS.body2}</small></p>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        bsStyle="danger"
                        onClick={onHide}
                        children={TEXTS.buttonLabelCancel.toUpperCase()}
                    />
                    <Button
                        bsStyle="success"
                        onClick={onAccept}
                        children={TEXTS.buttonLabelAccept.toUpperCase()}
                    />
                </Modal.Footer>
            </Modal>
        );
    }

}

OutsourceAssignmentConfirmModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onAccept: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/app/outsource/components/OutsourceAssignmentConfirmModal.js